/* eslint-disable no-unused-expressions */
import React, { createContext } from 'react'
import cookie from 'cookie'
import App, { Container } from 'next/app'
import Head from 'next/head'
import { withRouter } from 'next/router'
import NProgress from 'nprogress'
import 'styles/font.css'
import 'swiper/swiper-bundle.css'
import 'xgplayer/dist/xgplayer.min.css'
import PubSub from 'pubsub-js'
import 'static/iconfont/iconfont.css'
import 'static/din-font/iconfont.css'
import 'styles/emoji.css'
import 'styles/globals.css'
import Header2 from 'Components/header2'
import Header3 from 'Components/header3'
import NewHeader from 'Components/new-header'
import BackToTop from 'Components/back-to-top'
import RightSideNavigation from 'Components/right-side-navigation'
import { GlobalStoreProvider } from 'Components/store'
import { CacheStoreProvider } from 'Components/cache-store'
import getPageEnterId from 'lib/page-enter'
import getUrl from 'lib/url'
import registRealUser, { isRealUser } from 'lib/is-real-user'
import { getZT } from 'lib/zt-util'
import { unicodeToChar } from 'lib/utils'
import fetch from 'lib/decorated-fetch'
import teaInit, {
  sendTeaEnterEvent,
  sendTeaStayEvent,
  sendTeaCommEvent,
  teaConfig,
  teaStart,
  Tea,
  setPageId,
} from 'lib/tea-analyze'
import sendTeaLocationEvent from 'lib/get-location'
import safeGet from '@arsenal/arsenal/modules/safeGet'
import dynamic from 'next/dynamic'
import { logger, metrics } from 'lib/slardar-utils'
import SideNav from 'New/side-nav'
import isScroll from 'lib/routeChangeScroll'
import isCusPageEnter from 'lib/cusPageEnter'
import LoginStoreProvider from 'New/login/login-store'
import FeedNav from 'New/feed/nav'
import { isNewVersion } from 'lib/version'
import Wil from '@fe/wil'
import FeadbackProtalModal from 'New/side-nav/components/protal-modal'
import setVisitedSeries from 'lib/set-visited-series'
import StickyHeaderProvider from 'Components/new/sticky-header/sticky-header-provider'

const acrawler = require('@byted/acrawler')

const LiveStreamWindow = dynamic(
  () => import('Components/live-stream-window'),
  {
    ssr: false,
  }
)
class MyApp extends App {
  mainRef: React.RefObject<HTMLDivElement>

  paddingStyle: string

  unbindRealUser: () => any

  UNSAFE_componentWillMount() {
    // client side need fetch acrawler captcha token
    if (
      typeof window !== 'undefined' &&
      process.env.NODE_ENV !== 'development'
    ) {
      this.fetchAcrawlerCaptchaToken()
    }
  }

  constructor(props: any) {
    super(props)
    this.mainRef = React.createRef()
    this.paddingStyle = '0'
    this.unbindRealUser = null!
  }

  initSlardar(url = '') {
    const cookies = cookie.parse(document.cookie)
    const extraArr: string[] = []
    const pageId =
      url
        ?.toLocaleLowerCase()
        ?.split('?')?.[0]
        ?.split('/')
        ?.slice(1)
        ?.filter((path) => {
          if (/^\d+$/.test(path) || /-/.test(path)) {
            if (path) {
              extraArr.push(path)
            }

            return false
          }

          return true
        })
        ?.join('_') || 'homepage'
    window.Slardar('config', {
      sampleRate: 1,
      bid: 'motor_pc',
      pid: pageId,
      ignoreAjax: ['mcs.snssdk.com'],
      hookFetch: true,
      ignoreStatic: [],
      context: {
        tt_web_version: cookies?.tt_web_version || 'old',
        domain: window?.location?.host || 'unknow',
        extra: extraArr.join('_'),
      },
    })
  }

  /* eslint-disable complexity */
  componentDidMount() {
    if (this.props?.pageProps?._pageType === 'error') {
      return
    }
    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = 'manual'
    }

    let pageId = ''
    const { router } = this.props
    const routerPath = router.asPath || ''

    /** 当打开新tab时，浏览器可能复制当前sessionStorage到新的标签
     * 更多参考https://blog.techbridge.cc/2020/09/05/session-storage-and-html-spec/
     * 而pre_page_id的更新仅在当前页面切换时触发
     * url: A->(当前窗口切换) B->（新tab）-> C.
     * pre_page_id: '' -> A ->A, (所以c页面上报了pre_page_id=A 不符合预期, 需要新开页面时清掉pre_page_id）
     **/
    sessionStorage?.setItem('pre_page_id', '')

    const params = getPageEnterId(routerPath)
    pageId = params?.page_id ?? ''
    if (params.page_id === '') {
      metrics.counter('empty_page_id', {
        routerPath,
      })
    }
    // 首次渲染时初始化slardar
    this.initSlardar(routerPath)

    teaInit({
      appId: 1839,
      zt: getZT(),
      enable_stay_duration: true,
      maxDuration: 24 * 60 * 60 * 1000,
    })
    teaConfig({
      evtParams: {
        page_id: params?.page_id,
      },
      pc_real_user: isRealUser() ? true : false,
    })

    // 全局城市埋点
    sendTeaLocationEvent('init_top_location')

    if (params.page_id === 'page_pgc_video_detail') {
      teaConfig({
        evtParams: {
          content_type: 'pgc_video',
          group_id: (this.props.pageProps as any).gid,
          author_id: (this.props.pageProps as any).info?.media_user?.id,
        },
      })
    }
    const cookies = cookie.parse(document.cookie)
    let userData
    try {
      userData = JSON.parse(cookies.user_data)
    } catch (error) {
      metrics.counter('user_data.parse.exception', {
        userData: cookies.user_data,
      })
      logger.warn(
        `[user_data parsing failed] userData = ${cookies.user_data} error = ${error.message}`
      )
    }
    let is_dev
    let is_boe
    try {
      is_dev = JSON.parse(cookies.is_dev || 'null')
      is_boe = JSON.parse(cookies.is_boe || 'null')
    } catch (error) {
      metrics.counter('env.parse.exception')
      logger.warn(`[env parsing failed] error = ${error.message}`)
    }
    if (userData) {
      teaConfig({
        user_unique_id: userData?.user_id,
        user_id: userData?.user_id,
        user_is_login: true,
      })
    } else {
      teaConfig({
        user_is_login: false,
      })
    }
    if (is_dev || is_boe) {
      teaConfig({
        _staging_flag: 1,
      })
    }
    teaConfig({
      tt_web_version: cookies?.tt_web_version || 'old',
    })
    teaStart()
    if (isNewVersion() && isCusPageEnter(params?.page_id)) {
      setPageId(params.page_id)
      //do nothing 页面自定义处理 sendTeaEnterEvent
    } else {
      sendTeaEnterEvent(params)
    }
    setVisitedSeries(params)
    router.events.on('routeChangeStart', (url) => {
      // 前端路由变化时初始化slardar
      this.initSlardar(url)
      requestAnimationFrame(() => {
        NProgress.start()
        NProgress.set(0.5)
      })

      teaConfig({
        zt: getZT(),
      })
      sendTeaStayEvent()
      // 如果左侧有唤起浮层侧边栏则跳转需要隐藏
      PubSub.publish('OPEN_FIX_NAV', false)
    })

    // 首页因为雷达图性能问题不加埋点
    Wil(
      function (logEvent) {
        const {
          event: teaEvent,
          params,
          ...extra
        } = logEvent.log as {
          event: string
          params: any
        }

        const teaParams = { ...extra, ...params }

        if (logEvent.type === 'view-stay') {
          teaParams.stay_time = (logEvent as any).duration
        }
        console.log('==wil tea:', teaEvent, teaParams)
        sendTeaCommEvent(teaEvent, teaParams)
      },
      {
        intersectionObserverDebounced: {
          wait: 200,
          immediate: false,
        },
      }
    )

    router.events.on('routeChangeComplete', (url: string) => {
      teaConfig({
        pc_real_user: isRealUser() ? true : false,
      })
      const params = getPageEnterId(url)
      setVisitedSeries(params)
      if ((Tea as any)?.resetStayDuration) {
        ;(Tea as any).resetStayDuration(router?.asPath, document?.title, url)
      }

      teaConfig({
        evtParams: {
          page_id: params?.page_id,
        },
      })

      pageId = params?.page_id ?? ''

      // console.log('routeChangeComplete', url)
      requestAnimationFrame(() => {
        NProgress.done()
      })
      if (isScroll(url)) {
        window.scrollTo(0, 0)
      }

      if (isNewVersion() && isCusPageEnter(params?.page_id)) {
        //do nothing 页面自定义处理 sendTeaEnterEvent
        return
      }
      if (params.page_id === 'page_pgc_video_detail') {
        teaConfig({
          evtParams: {
            content_type: 'pgc_video',
            group_id: (this.props.pageProps as any).gid,
            author_id: (this.props.pageProps as any).info?.media_user?.id,
          },
        })
      } else {
        teaConfig({
          evtParams: {
            content_type: undefined,
            group_id: undefined,
            author_id: undefined,
          },
        })
      }
      sendTeaEnterEvent(params)
    })
    router.events.on('routeChangeError', () => {
      requestAnimationFrame(() => {
        NProgress.done()
      })
    })
    router.beforePopState(({ as }) => {
      // ie9不支持history
      if (!window.history || !window.history.pushState) {
        window.open(as)
        // window.location.href = as
        return false
      }
      return true
    })

    const scrollBarWidth =
      window.innerWidth -
      (document.documentElement || document.body).clientWidth
    if (scrollBarWidth > 0) {
      const node = this.mainRef.current
      if (node && !/(theater|full)/.test(this.props.pageProps?._pageType)) {
        node.style.paddingRight = `calc(4% - ${scrollBarWidth}px)`
      }
    }

    PubSub.subscribe('modify-padding', (eventName: string, signal: 0 | 1) => {
      if (!this.mainRef.current) {
        return
      }
      if (signal === 0) {
        this.mainRef.current.style.padding = '0'
      } else {
        this.mainRef.current.style.padding = `0 calc(4% - ${scrollBarWidth}px) 0 4%`
      }
    })

    this.unbindRealUser = registRealUser()
  }

  componentWillUnmount() {
    PubSub.unsubscribe('modify-padding')
    if (this.unbindRealUser) {
      this.unbindRealUser()
    }
  }

  fetchAcrawlerCaptchaToken = () => {
    fetch(getUrl('/acrawler/get_captcha_token'))
      .then((data) => {
        const token = safeGet(data, 'token') || ''
        const result = token.match(/tac='(.*)'/)

        if (result) {
          window['tac'] = unicodeToChar(result[1])
        }

        this.fetchAcrawlerCaptchaCheck()
      })
      .catch((e) => {
        console.error('token', e)
      })
  }

  fetchAcrawlerCaptchaCheck = () => {
    const nonce = {
      url: encodeURI(`${window.location.origin}/acrawler/check_captcha`),
    }

    let sig = ''
    try {
      sig = acrawler.sign(nonce)
    } catch (e) {
      console.error('token', e)
    }

    fetch(getUrl(`/acrawler/check_captcha?_signature=${sig}`)).catch((e) => {
      console.error(e)
    })
  }

  renderHeader = (_pageType: string | undefined, _cusHeadType: string) => {
    if (_pageType) {
      return <NewHeader pageType={_pageType} cusHeadType={_cusHeadType || ''} />
    }
    const { router } = this.props
    const routerPath = router.asPath || ''
    const params = getPageEnterId(routerPath)
    if (
      [
        'page_series_home',
        'page_series_video_list',
        'page_series_article_list',
        'page_series_qa_list',
      ].includes(params?.page_id || '')
    ) {
      return <Header3 />
    }
    return <Header2 />
  }

  renderContent = (props: any) => {
    const { Component, pageProps } = props
    if (!pageProps?._pageType) {
      return (
        <main>
          <Component {...pageProps} />
        </main>
      )
    }

    return (
      <div
        className="tw-flex"
        style={{ maxWidth: 1920, minWidth: 1024, margin: '0 auto' }}
      >
        {pageProps?._pageType?.indexOf('no-nav') > -1 ? null : (
          <SideNav pageType={pageProps?._pageType} />
        )}
        {pageProps?._pageType?.indexOf('feed') > -1 ? <FeedNav /> : null}
        <div
          className={`new-main ${pageProps?._pageClassName || ''} ${
            pageProps?._pageType || ''
          }`}
          ref={this.mainRef}
        >
          <Component {...pageProps} />
        </div>
      </div>
    )
  }

  render() {
    const { pageProps, router, Component } = this.props
    if (
      router?.asPath?.indexOf('/404') === 0 ||
      router?.route?.indexOf('/404') === 0
    ) {
      if (typeof window !== 'undefined') {
        pageProps._pageType = isNewVersion() ? 'new' : ''
        pageProps._pageClassName = 'page-404'
      } else {
        return null!
      }
    }

    // 如果是错误页，什么额外组件都不要，避免进入死循环
    if (pageProps?._pageType === 'error') {
      return <Component {...pageProps} />
    }

    return (
      <Container>
        <Head>
          <title key="title">懂车帝 - 说真的还得懂车帝</title>
          <meta
            key="keywords"
            name="keywords"
            content="懂车帝官网,汽车,汽车网站,汽车网,汽车报价,汽车报价大全,汽车图片,新闻,评测,视频,车型库,车型,车型大全,参数,配置,报价,汽车之家,车友,车友圈,社区,俱乐部"
          />
          <meta
            key="description"
            name="description"
            content="懂车帝是一个汽车资讯平台，懂车更懂你。懂车帝资讯平台会聪明地分析你的兴趣爱好，自动为你推荐喜欢的汽车内容，提供最新汽车报价，汽车图片，汽车价格大全，汽车新闻、行情、评测、导购等内容，是提供信息最快最全的中国汽车网站，看车选车买车就上懂车帝。"
          />
          <meta
            name="viewport"
            content="width=device-width,initial-scale=1,maximum-scale=5,minimum-scale=1,viewport-fit=cover"
          />
        </Head>
        <CacheStoreProvider>
          <GlobalStoreProvider>
            <LoginStoreProvider>
              <StickyHeaderProvider>
                {this.renderHeader(
                  pageProps?._pageType,
                  pageProps?._cusHeadType
                )}
                {this.renderContent(this.props)}
                {pageProps?._pageType ? (
                  <BackToTop bottom={pageProps?._pageBackToTopBtnBottom} />
                ) : (
                  <RightSideNavigation />
                )}
              </StickyHeaderProvider>
            </LoginStoreProvider>
            <LiveStreamWindow />
          </GlobalStoreProvider>
        </CacheStoreProvider>
        <FeadbackProtalModal />
        <style jsx global>
          {`
            /* Make clicks pass-through */

            #nprogress {
              pointer-events: none;
            }
            body {
              overflow-x: auto;
              overflow-y: scroll;
              background: ${pageProps?._pageType ? '#E6E8F2' : '#fff'};
              min-width: 1024px;
            }
            #nprogress .bar {
              position: fixed;
              z-index: 1999;
              top: ${pageProps?._pageType ? '84px' : '0'};
              left: 0;
              width: 100%;
              height: 2px;
              background: #ffe100;
            }

            /* Fancy blur effect */
            #nprogress .peg {
              display: block;
              position: absolute;
              right: 0px;
              width: 100px;
              height: 100%;
              box-shadow: 0 0 10px #ffe100, 0 0 5px #ffe100;
              opacity: 1;

              -webkit-transform: rotate(3deg) translate(0px, -4px);
              -ms-transform: rotate(3deg) translate(0px, -4px);
              transform: rotate(3deg) translate(0px, -4px);
            }

            .new-main {
              flex: 1;
              padding: 0 4%;
              background: #f7f8fc;
            }
            .page-404 {
              background: none;
            }
            .video-detail {
              background: #f2f4fa;
            }
            .new-main.theater {
              padding: 0;
            }
            .new-main.adapted-padding {
              padding-top: 0;
              padding-bottom: 0;
              padding-left: 4%;
            }
            .new-main.full {
              padding: 0;
            }
          `}
        </style>
      </Container>
    )
  }
}

export default withRouter(MyApp)
